import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import Slider from '@material-ui/lab/Slider';
import Switch from '@material-ui/core/Switch';
import Paper from '@material-ui/core/es/Paper/Paper';
import Close from '@material-ui/icons/Close';

import { getOptions } from '../../lib/optionsHelper';
import { manipulateMelodyByConfig } from '../../lib/scoreHelper';
import { drawLengthSquaresOverAll } from '../../lib/scorePainterHelper';
import abcjsObj from 'abcjs';
import {
  option_dialog_classes,
  radio_classes,
  switch_classes,
  slider_classes,
  grid_classes
} from '../../lib/classNames';

const melodySample = `
X:1
L:1/4
M:4/4
K:C
V:1
 E E/E/ G G/G/ | B B/B/ d d/d/ | f f/f/ z2 |
w: Mi Mi Mi Sol Sol Sol | Si Si Si Re Re Re | Fa Fa Fa |
 E E/E/ G G/G/ | B B/B/ d d/d/ | f f/f/ z2 |
w: Mi Mi Mi Sol Sol Sol | Si Si Si Re Re Re | Fa Fa Fa |
 E E/E/ G G/G/ | B B/B/ d d/d/ | f f/f/ z2 |
w: Mi Mi Mi Sol Sol Sol | Si Si Si Re Re Re | Fa Fa Fa |
`;

const horizontalMelodySample = `
X:1
L:1/4
M:4/4
K:C
V:1
 E E/E/ G G/G/ | B B/B/ d d/d/ | f f/f/ z2 |
w: Mi Mi Mi Sol Sol Sol | Si Si Si Re Re Re | Fa Fa Fa |
`;

class Options extends PureComponent {
  static propTypes = {
    onClose: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = getOptions();
    this.abcjsCanvasRef = React.createRef();
  }

  render() {
    const { onClose } = this.props;

    const { staffOrientation, lineSpacing, notesNameVisible, noteLengthVisible } = this.state;

    let abcHolderClasses = 'Abc-Holder';
    if (staffOrientation === 'horizontal') {
      const lineSpacingClasses = ['Small', 'Normal', 'Large'];
      abcHolderClasses += ' Abc-Staff-Horizontal';
      abcHolderClasses += ' Abc-' + lineSpacingClasses[lineSpacing] + '-Score';
    }

    return (
      <Grid classes={grid_classes} container direction="column" justify="space-between">
        <Grid item container direction={'row-reverse'} justify="center">
          <Grid item xs={10}>
            <div className="closediv">
              <button className="Options-Close" onClick={onClose}>
                <Close />
              </button>
            </div>
          </Grid>
        </Grid>
        <Grid item container direction={'row'} justify="center" spacing={24}>
          <Grid item xs={10} md={4}>
            <Paper className={option_dialog_classes.paper}>
              <table className={option_dialog_classes.table}>
                <tbody>
                  <tr className={option_dialog_classes.tr}>
                    <th className={option_dialog_classes.th}>Pentagramma</th>
                    <td className="radioc">
                      <div className="hor">
                        <Radio
                          classes={radio_classes}
                          checked={staffOrientation === 'vertical'}
                          onChange={this.handleChange}
                          value="vertical"
                          name="staffOrientation"
                          aria-label="vertical"
                        />
                        <label>verticale</label>
                      </div>
                      <div className="ver">
                        <Radio
                          classes={radio_classes}
                          checked={staffOrientation === 'horizontal'}
                          onChange={this.handleChange}
                          value="horizontal"
                          name="staffOrientation"
                          aria-label="horizontal"
                        />
                        <label>orizzontale</label>
                      </div>
                    </td>
                  </tr>
                  {staffOrientation === 'horizontal' && [
                    <tr className={option_dialog_classes.tr}>
                      <th className={option_dialog_classes.th}>Zoom</th>
                      <td>
                        <div className={option_dialog_classes.sliderWrapper}>
                          <Slider
                            classes={slider_classes}
                            name="lineSpacing"
                            value={lineSpacing}
                            onChange={this.handleLineSpacing}
                            max={2}
                            min={0}
                            step={1}
                          />

                          <Grid
                            container
                            justify="space-between"
                            direction="row"
                            className={option_dialog_classes.sliderLegend}
                          >
                            <Grid item>piccolo</Grid>
                            <Grid item>medio</Grid>
                            <Grid item>grande</Grid>
                          </Grid>
                        </div>
                      </td>
                    </tr>,
                    <tr className={option_dialog_classes.tr}>
                      <th className={option_dialog_classes.th}>Nomi delle note</th>
                      <td>
                        <Switch
                          classes={switch_classes}
                          name="notesNameVisible"
                          checked={notesNameVisible}
                          onChange={this.handleChange}
                          value="1"
                        />
                      </td>
                    </tr>,
                    <tr className={option_dialog_classes.tr}>
                      <th className={option_dialog_classes.th}>Durata delle note</th>
                      <td>
                        <Switch
                          classes={switch_classes}
                          name="noteLengthVisible"
                          checked={noteLengthVisible}
                          onChange={this.handleChange}
                          value="1"
                        />
                      </td>
                    </tr>
                  ]}
                </tbody>
              </table>
            </Paper>
          </Grid>
          <Grid item xs={10} md={6}>
            <Paper className={option_dialog_classes.paper} style={{ minHeight: (window.innerHeight / 3) * 2 }}>
              <h2>Vuoi evidenziare una linea?</h2>
              <div className="instructions">
                Se vuoi aiutarti nell'identificare le note sul pentagramma, prova a evidenziare una linea cliccando
                sulle note qui sotto.
              </div>
              <div
                id={'abcjs-sample'}
                className={abcHolderClasses}
                style={{ width: '100%' }}
                ref={this.abcjsCanvasRef}
              />
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  componentDidMount() {
    this.renderAbcNotation();
    window.addEventListener('resize', this.resizeNotations);
    
  }
  componentWillUnmount(){
    window.removeEventListener('resize', this.resizeNotations);
  }

  resizeNotations = (event)=>{
   const lineSpacing = localStorage.getItem('lineSpacing');
   if(lineSpacing && this.state){
    this.setState({ lineSpacing: lineSpacing });
    this.renderAbcNotation();
    console.log("resizing notations")
   }
    
  }

  handleLineSpacing = (event, value) => {
    this.setState({ lineSpacing: value });
    localStorage.setItem('lineSpacing', value);
    this.renderAbcNotation();
  };

  handleChange = event => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({ [name]: value }, this.renderAbcNotation);
    localStorage.setItem(name, value);
  };

  noteNameFromPathClasses = noteElement => {
    const classes = [];
    noteElement.classList.forEach(className => {
      if (className.startsWith('abcjs-p')) classes.push(className);
    });
    if (classes) return parseInt(classes[0].replace('abcjs-p', ''));
  };

  toggleSelectionForLine = scoreLineNumber => {
    console.log('clicked on the ', scoreLineNumber);
    if (this.state.selectedStaffLine === scoreLineNumber) {
      scoreLineNumber = -1;
    }
    this.setState({ selectedStaffLine: scoreLineNumber });
    localStorage.setItem('selectedStaffLine', scoreLineNumber);
    this.renderAbcNotation();
  };

  onNoteClicked = abcElem => {
    if (abcElem && abcElem.abselem && abcElem.abselem.elemset && abcElem.abselem.elemset.length > 0) {
      const noteElement = abcElem.abselem.elemset.filter(element => element.classList.contains('abcjs-note'))[0];
      const noteNumber = this.noteNameFromPathClasses(noteElement);
      // 2 -> E -> 5
      // 4 -> G -> 4
      // 6 -> B -> 3
      // 8 -> d -> 2
      // 10 -> f -> 1
      const staffLineIndex = (10 - noteNumber) / 2;
      this.toggleSelectionForLine(staffLineIndex);
    }
  };

  setupSvgStaffLines = (svgStaffLineElement, index) => {
    if (index === getOptions().selectedStaffLine) svgStaffLineElement.setAttribute('fill', 'red');
    svgStaffLineElement.setAttribute('class', svgStaffLineElement.getAttribute('class') + ' abcjs-staff_line' + index);
    svgStaffLineElement.addEventListener('mouseup', event => {
      this.toggleSelectionForLine(index);
    });
  };

  renderAbcNotation() {
    if(!this.state){
      console.warn("can't resize abc notation")
      return;
    }
    const { staffOrientation, notesNameVisible, noteLengthVisible } = this.state;
    const engraverParams = { add_classes: true };
    const renderParams = {
      responsive: 'resize',
      clickListener: this.onNoteClicked
    };
    let sampleScore = this.state.staffOrientation === 'vertical' ? melodySample : horizontalMelodySample;
    sampleScore = manipulateMelodyByConfig(sampleScore, staffOrientation, notesNameVisible, noteLengthVisible);

    if (this.state.staffOrientation === 'vertical') {
      engraverParams.responsive = 'resize';
    } else {
      renderParams.scrollHorizontal = true;
      renderParams.viewportHorizontal = true;
      if (this.state.staffOrientation === 'horizontal') {
        document.querySelector('#abcjs-sample').style.removeProperty('padding-bottom');
      }
    }

    this.tunes = abcjsObj.renderAbc('abcjs-sample', sampleScore, {}, engraverParams, renderParams);

    this.tunes[0].lines.forEach((x, lineNumber) => {
      const lines = this.abcjsCanvasRef.current.querySelectorAll('.abcjs-staff.abcjs-l' + lineNumber);
      lines.forEach(this.setupSvgStaffLines);
    });

    if (staffOrientation === 'horizontal' && noteLengthVisible) {
      drawLengthSquaresOverAll(this.abcjsCanvasRef.current, this.tunes[0].engraver.renderer.paper);
    }
  }
}

export default Options;
